/**
=========================================================
* Annotation Portal React - v2.2.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-react
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// Annotation Portal React base styles
import borders from "assets/theme/base/borders";

const { borderRadius } = borders;

const dialog = {
  styleOverrides: {
    root: {
      "& .MuiBackdrop-root": {
        backgroundColor: "rgba(15, 23, 42, 0.45)",
        backdropFilter: "blur(2px)",
      },
    },

    paper: {
      borderRadius: borderRadius.xxl,
      boxShadow: "0 24px 60px -12px rgba(15, 23, 42, 0.28)",
      border: "1px solid rgba(15, 23, 42, 0.06)",
    },

    paperFullScreen: {
      borderRadius: 0,
    },
  },
};

export default dialog;
